import React from 'react';
import './Logo.css';

const Logo = React.memo(({ size = 'medium', showText = true }) => {
  return (
    <div className={`logo-container logo-${size}`}>
      <img 
        src="/images/logo.jpeg" 
        alt="EventsCore Solutions Logo"
        className="logo-image"
      />
      {showText && (
        <div className="logo-text">
          <div className="logo-text-event">EVENT</div>
          <div className="logo-text-core">CORE</div>
          <div className="logo-text-solutions">SOLUTIONS</div>
        </div>
      )}
    </div>
  );
});

Logo.displayName = 'Logo';

export default Logo;

